'use strict';

/**
 *
 * @name: modulesAnalytics
 *
 */

function ModulesAnalyticsFactory($analytics) {

  'ngInject';

  function mosaic(network) {

    var properties = {
      eventAction: 'Nowness Live',
      attributes: {
        label: network
      }
    };

    return $analytics.eventTrack('Social Networks', properties);
  }

  function shopTheSale(shopName, index) {

    var moreIndex;

    if (index === 0) {

      moreIndex = 'More to love Left';
    } else if (index === 1) {

      moreIndex = 'More to love Center';
    } else if (index === 2) {

      moreIndex = 'More to love Right';
    }

    var properties = {
      eventAction: 'More to love from around the web | ' + moreIndex,
      eventPoints: 0,
      attributes: {
        label: shopName
      }
    };

    return $analytics.eventTrack('Article Page', properties);
  }

  return {
    mosaic: mosaic,
    shopTheSale: shopTheSale
  };
}

export default ModulesAnalyticsFactory;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-modules-analytics.factory.js